import { injectable, inject } from 'inversify';
import { DataroomTenant } from '@dataroom/tenant/DataroomTenant';
import { type IDispatcherFactory } from '@dataroom/json-rpc-dispatcher';
import DataroomDITypes from '@dataroom/json-rpc-dispatcher/DITypes';
import Request from '@framework/api/Rpc/Request';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import { ICreateSessionPayload } from './interfaces';

@injectable()
class SessionRepository {
  constructor(
    @inject(DataroomDITypes.JsonRpcDispatcher) private readonly dataroomJsonRpcDispatcher: IDispatcherFactory,
  ) {}

  /**
   * Create session for dataroom
   */
  async createDataroomSession(data: ICreateSessionPayload, tenant: DataroomTenant): Promise<string> {
    const request = new Request('user.authenticate', data);
    const response = await this.dataroomJsonRpcDispatcher(tenant).call<RpcSuccess>(request);

    return response.getResult().ssid;
  }

  /**
   * Verify that current session is valid for DealVDR
   */
  async verifyDataroomSession(tenant: DataroomTenant) {
    const request = new Request('user.verify_session');
    const response = await this.dataroomJsonRpcDispatcher(tenant).call<RpcSuccess>(request);

    return response.getResult();
  }
}

export default SessionRepository;
